<template>
  <div class="status-charging-history">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="Search" label-for="historySearchBox"
                              label-cols="3" content-cols="9">
                  <b-input-group>
                    <b-form-input id="historySearchBox" type="search" v-model="searchForm.word" @input="resetShowDetails" />
                  </b-input-group>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회 기간" label-for="historySearchPeriod"
                              label-cols="3" content-cols="9">
                  <date-picker id="historySearchPeriod" v-model="searchForm.period"
                               range append-to-body value-type="format" lang="ko"
                               :disabled-date="disabledAfterToday" @input="getItems">
                    <template v-slot:footer="{ emit }">
                      <div class="text-start">
                        <b-button size="sm" variant="outline-primary me-1" class="" @click="emit([new Date(), new Date()])">
                          오늘
                        </b-button>
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodOneMonth(emit, 'today')">
                          1개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary me-1" @click="$_utils.periodThreeMonth(emit, 'today')">
                          3개월
                        </b-button>
                        <b-button size="sm" variant="outline-primary" @click="$_utils.periodSixMonth(emit, 'today')">
                          6개월
                        </b-button>
                      </div>
                    </template>
                  </date-picker>
                </b-form-group>
              </div>
              <div class="col-xl-3 col-lg-4">
                <b-form-group label-class="col-form-label"
                              label="종료 사유" label-for="searchStopReason"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStopReason"
                               v-model="searchForm.stopReason" :options="stopReasonOptions"
                               label="text" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               :max-height="202" @input="getItems">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
              <div class="col-xl" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Charging History List -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-0">
          <div class="card-body">

            <div class="row mb-3">
              <div class="col">
                <div class="float-end me-2">
                  <total-count :count="pagination.totalCount" :total-count="totalCount" unit="건"/>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table class="datatables text-nowrap" bordered hover
                       :fields="fields" :items="items"
                       :filter="searchForm.word"
                       :filter-included-fields="filterOn"
                       :filter-debounce="150"
                       :per-page="pagination.perPage"
                       :current-page="pagination.currentPage"
                       @filtered="onFiltered"
                       @row-clicked="rowClick">

                <template #cell(startTime)="data">
                  {{ $_utils.changeDateFormat(data.item.startTime, 'YYYY-MM-DD HH:mm:ss') }}
                </template>
                <template #cell(endTime)="data">
                  {{ $_utils.changeDateFormat(data.item.endTime, 'YYYY-MM-DD HH:mm:ss') }}
                </template>
                <template #cell(leadTime)="data">
                  {{ !$_utils.isEmpty(data.item.leadTime) ? $_utils.comma(data.item.leadTime) : '' }}
                </template>

                <template #row-details="data">
                  <b-card class="row-detail mb-0">
                    <ul class="mb-0">
                      <li>Transaction ID : <span class="ct-text-main">{{ data.item.transactionId }}</span></li>
                      <li>충전소 ID : <span class="ct-text-main">{{ data.item.placeId }}</span></li>
                      <li>충전소 : <span class="ct-text-main">{{ data.item.placeName }}</span></li>
                      <li>충전기 ID : <span class="ct-text-main">{{ data.item.csoEvseNum }}</span></li>
                      <li>회원 번호 : <span class="ct-text-main">{{ data.item.userId }}</span></li>
                      <li>회원 유형 : <span class="ct-text-main">{{ $_app.code.userType[data.item.userType] }}</span></li>
                      <li>충전 시작 시간 : <span class="ct-text-main">{{ $_utils.changeDateFormat(data.item.startTime, 'YYYY-MM-DD HH:mm:ss') }}</span></li>
                      <li>충전 종료 시간 : <span class="ct-text-main">{{ $_utils.changeDateFormat(data.item.endTime, 'YYYY-MM-DD HH:mm:ss') }}</span></li>
                      <li>충전 소요 시간 : <span class="ct-text-main">{{ $_utils.comma(data.item.leadTime) }}</span><span class="ct-text-muted"> 분</span></li>
                      <li>충전량 : <span class="ct-text-main">{{ $_utils.comma(data.item.totEnergy) }}</span><span class="ct-text-muted"> kWh</span></li>
                      <li>충전 금액 : <span class="ct-text-main">{{ $_utils.comma(data.item.totCost) }}</span><span class="ct-text-muted"> 원</span></li>
                      <li>충전 종료 사유 : <span class="ct-text-main">{{ data.item.stoppedReason }}</span></li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
            </div>

            <div class="row mt-3">
              <div class="col mt-2">
                <b-pagination class="pagination-no-border" size="sm" align="center" v-model="pagination.currentPage"
                              first-number last-number prev-text="<" next-text=">"
                              :total-rows="pagination.totalCount"
                              :per-page="pagination.perPage"
                              @change="resetShowDetails" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- END Charging History List -->

  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TotalCount from '@/views/components/totalCount.vue';
import { http } from '@/mdk/auth-api';

export default {
  components: { Multiselect, TotalCount },
  data() {
    return {
      searchForm: {
        word: null,
        // period: [new Date(moment().subtract(6, 'd').format('YYYY-MM-DD')), new Date()],
        period: [
          moment().date(1).format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        stopReason: { value: '', text: '전체' }
      },
      stopReasonOptions: [
        { value: '', text: '전체' },
        { value: 'DeAuthorized', text: 'DeAuthorized' },
        { value: 'EmergencyStop', text: 'EmergencyStop' },
        { value: 'EnergyLimitReached', text: 'EnergyLimitReached' },
        { value: 'EVDisconnected', text: 'EVDisconnected' },
        { value: 'GroundFault', text: 'GroundFault' },
        { value: 'ImmediateReset', text: 'ImmediateReset' },
        { value: 'Local', text: 'Local' },
        { value: 'LocalOutOfCredit', text: 'LocalOutOfCredit' },
        { value: 'MasterPass', text: 'MasterPass' },
        { value: 'Other', text: 'Other' },
        { value: 'OvercurrentFault', text: 'OvercurrentFault' },
        { value: 'PowerLoss', text: 'PowerLoss' },
        { value: 'PowerQuality', text: 'PowerQuality' },
        { value: 'Reboot', text: 'Reboot' },
        { value: 'Remote', text: 'Remote' },
        { value: 'SOCLimitReached', text: 'SOCLimitReached' },
        { value: 'StoppedByEV', text: 'StoppedByEV' },
        { value: 'TimeLimitReached', text: 'TimeLimitReached' },
        { value: 'Timeout', text: 'Timeout' }
      ],
      totalCount: 0,
      filterOn: ['transactionId', 'placeId', 'placeName', 'csoEvseNum', 'userId'],
      fields: [
        { key: 'transactionId', label: 'Transaction ID', sortable: true, class: 'text-center' },
        { key: 'placeId', label: '충전소 ID', sortable: true, class: 'text-center' },
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'csoEvseNum', label: '충전기', sortable: true, class: 'text-center' },
        { key: 'startTime', label: '충전 시작', sortable: true, class: 'text-center' },
        { key: 'endTime', label: '충전 종료', sortable: true, class: 'text-center' },
        { key: 'leadTime', label: '소요 시간 (분)', sortable: true, class: 'text-center' },
        { key: 'userId', label: '회원 번호', sortable: true, class: 'text-center' },
        { key: 'stoppedReason', label: '종료 사유', sortable: true, class: 'text-center' }
      ],
      items: [],
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10
      }
    }
  },
  created() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems() {
      const vm = this;
      const _url = `/onmapi/transaction/list`;

      if (vm.searchForm.period.length < 1 || this.$_utils.isEmpty(vm.searchForm.period[0])) {
        vm.searchForm.period = [new Date(moment().subtract(6, 'd').format('YYYY-MM-DD')), new Date()];
      }

      /*this.$axios.get(_url, {*/
      http.get(_url, {
        params: {
          startDate: moment(vm.searchForm.period[0]).format('YYYY-MM-DD'),
          endDate: moment(vm.searchForm.period[1]).format('YYYY-MM-DD'),
          stopReason: vm.searchForm.stopReason.value
        }
      }).then((res) => {
        vm.items = res.data.result;
        vm.pagination.totalCount = res.data.searchCount;
        vm.totalCount = res.data.totalCount;
      }).catch(err => {
        console.log('Get Charging History List Error :: ', err)
      });
    },
    disabledAfterToday(date) {
      return date > moment();
    },
    onFiltered(filteredItems) {
      const vm = this;

      if (vm.pagination.totalCount !== filteredItems.length) {
        vm.pagination.currentPage = 1;
      }

      vm.pagination.totalCount = filteredItems.length;
    },
    rowClick(row) {
      const vm = this;

      if (row._showDetails) {
        this.$set(row, '_showDetails', false);
      } else {
        vm.items.forEach(item => {
          this.$set(item, '_showDetails', false);
        });

        vm.$nextTick(() => {
          this.$set(row, '_showDetails', true);
        });
      }
    },
    resetShowDetails() {
      const vm = this;

      vm.items.forEach(item => {
        this.$set(item, '_showDetails', false);
      });
    }
  }
}
</script>
